"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dot = require("../dot");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StatusDot = (0, _styledComponents.default)(_dot.Dot)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  margin-right: ", ";\n"])), function (_ref) {
  var dotPosition = _ref.dotPosition;
  return dotPosition === 'right' && '5px';
}, function (_ref2) {
  var dotPosition = _ref2.dotPosition;
  return dotPosition === 'left' && '5px';
});
var Title = _styledComponents.default.div.attrs(function (_ref3) {
  var dotProps = _ref3.dotProps,
    text = _ref3.text,
    noText = _ref3.noText,
    _ref3$dotPosition = _ref3.dotPosition,
    dotPosition = _ref3$dotPosition === void 0 ? 'left' : _ref3$dotPosition;
  return {
    children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, dotPosition === 'left' && /*#__PURE__*/_react.default.createElement(StatusDot, _extends({
      dotPosition: dotPosition
    }, dotProps)), !noText && text, dotPosition === 'right' && /*#__PURE__*/_react.default.createElement(StatusDot, _extends({
      dotPosition: dotPosition
    }, dotProps)))
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n"])));
exports.Title = Title;